<template>
    <div>
        <van-nav-bar
            title="消费记录"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-tabs type="card" color="#488aff" style="width:100%;">
            <van-tab title="服务单">
                <CarTabs @tabClick="tabClick" />
                <van-list
                    v-model="serviceOrderLoading"
                    :finished="serviceOrderFinished"
                    finished-text="没有更多了"
                    @load="serviceOrderOnLoad"
                >
                    <van-cell-group>
                        <van-cell title="服务单消费明细"  size="large" />
                        <van-cell v-for="item in serviceOrderList" :key="item.id" :title="item.repair_service_name"  size="large" class="item" @click="goDetails(item)">
                            <template slot="label">
                                <span style="display:block;">{{ item.car_code }}</span>
                                <span style="display:block;">{{"日期："}}{{item.bill_date | moment("YYYY-MM-DD HH:mm") }}</span>
                                <span style="display:block;">{{"日期："}}{{item.bill_date | moment("YYYY-MM-DD HH:mm") }}</span>
                                <span style="display:block;">{{"价格："}}{{item.total_amount }}(现金{{item.rev_amount}}/储值卡{{item.storedvaluecard_amount}})</span>
                                <span style="display:block;">{{"抵扣："}}{{item.deduct_style}}</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <van-tab title="充值单">
                <van-list
                    v-model="vipRechargeLoading"
                    :finished="vipRechargeFinished"
                    finished-text="没有更多了"
                    @load="vipRechargeOnLoad"
                >
                    <van-cell-group>
                        <van-cell title="充值消费明细"  size="large" />
                        <van-cell v-for="item in vipRechargeList" :key="item.id" :title="item.style==1?'储值卡消费':'套餐卡消费'"  class="item" size="large">
                            <template slot="label">
                                <span style="display:block;">{{"日期："}}{{item.create_date | moment("YYYY-MM-DD HH:mm") }}</span>
                                <span style="display:block;" v-if="item.style==1">{{"内容：储值卡"}}{{item.number }}</span>
                                <span style="display:block;" v-else>{{"内容：套餐卡"}}{{item.number }}{{item.package_name}}</span>
                                <span style="display:block;" v-if="item.style==1">金额：充值{{item.amount }}/实付{{item.real_amount}}</span>
                                <span style="display:block;" v-else>{{"金额："}}{{item.amount }}</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <!-- <van-tab title="车品">
                <van-list
                    v-model="salesOrderLoading"
                    :finished="salesOrderFinished"
                    finished-text="没有更多了"
                    @load="salesOrderOnLoad"
                >
                    <van-cell-group>
                        <van-cell title="车品消费明细"  size="large" />
                        <van-cell v-for="item in salesOrderList" :key="item.id" :title="item.items" size="large">
                            <template slot="label">
                                <span style="display:block;">{{"付款方式："}}{{item.style_type ? item.style_type : '现金'}}</span>
                                <span style="display:block;">{{"价格："}}{{item.sales_amount}}</span>
                                <span style="display:block;">{{"日期："}}{{item.bill_date|moment("YYYY-MM-DD HH:mm")}}</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab> -->
        </van-tabs>
    </div>
</template>

<script>
import { NavBar, Tab, Tabs, List, Cell, CellGroup } from 'vant';
import { RepairServiceOrderApi, VipMemberRechargeApi } from '@/api/vip'
import { getCars } from '@/utils/localutils'
import CarTabs from '@/view/user/components/cartabs' 

export default {
    components: {
        [NavBar.name]: NavBar,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [List.name]: List,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        CarTabs,
    },
    data() {
        return {
            serviceOrderList: [],
            serviceOrderLoading: false,
            serviceOrderFinished: false,
            serviceOrderQuery: {
                page: 0,
                cur_car: 0
            },
            vipRechargeList: [],
            vipRechargeLoading: false,
            vipRechargeFinished: false,
            vipRechargeQuery: {
                page: 0
            },
            salesOrderList: [],
            salesOrderLoading: false,
            salesOrderFinished: false,
            salesOrderQuery: {
                page: 0
            },
        }
    },
    mounted(){
        const cars = getCars()
        console.log(cars)
    },
    methods: {
        serviceOrderOnLoad(){
            this.serviceOrderQuery.page = this.serviceOrderQuery.page + 1
            this.getRepairServiceOrder()
        },
        getRepairServiceOrder(){
            var that = this
            that.axios.get(RepairServiceOrderApi, {params: that.serviceOrderQuery}).then((ret) => {
                this.serviceOrderLoading = false
                this.serviceOrderList = ret.results
                if (ret.results == null || ret.results.length ===0 || ret.next == null) {
                    that.serviceOrderFinished = true
                    return
                 }
            })
        },
        vipRechargeOnLoad(){
            this.vipRechargeQuery.page = this.vipRechargeQuery.page + 1
            this.getVipRecharge()
        }, 
        getVipRecharge(){
            var that = this
            that.axios.get(VipMemberRechargeApi, {params: that.vipRechargeQuery}).then((ret) => {
                this.vipRechargeLoading = false
                ret.results.forEach(item => {
                    this.vipRechargeList.push(item)
                })
                if (ret.results == null || ret.results.length ===0 || ret.next == null) {
                    that.vipRechargeFinished = true
                    return
                 }
            })
        },
        salesOrderOnLoad(){
            this.salesOrderQuery.page = this.salesOrderQuery.page + 1
            this.getSalesOrder()
        }, 
        // getSalesOrder(){
        //     var that = this
        //     that.axios.get(SalesOrderApi, {params: that.salesOrderQuery}).then((ret) => {
        //         console.log(ret)
        //         this.salesOrderLoading = false
        //         // ret.results.forEach(item => {
        //         //     this.salesOrderList.push(item)
        //         // })
        //         // this.salesOrderList.forEach(item => {
        //         //     item.style_type = ''
        //         //     item.sales_order_item = item.items.join(',')
        //         //     item.detail.forEach(it => {
        //         //         if (item.style_type != '') item.style_type += ','
        //         //         item.style_type += it.style_type;
        //         //     })
        //         // })
        //         // if (ret.results == null || ret.results.length ===0 || ret.next == null) {
        //         //     that.salesOrderFinished = true
        //         //     return
        //         // }
        //     })
        // },
        tabClick(item) {
            this.serviceOrderQuery.cur_car = item.id
            this.getRepairServiceOrder()
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        },
        goDetails(item) {
            this.$router.push(`/nt/repair/${item.id}`)
        }
    }
}
</script>

<style lang="less" scoped>
.item {
    margin-bottom: 20px;
    padding-bottom: 12px;
    padding-top: 12px;
    background-color: #203864;
    margin-right: 12px;

    .van-cell__title {
        font-size: 1.2em;
        font-weight: bold;
        color: #D8D8D8;
        margin-bottom: 8px;
    }

    .van-cell__label {
        color: #D8D8D8;
    }
}
</style>